import md5 from 'crypto-js/md5'

import { getApiOrigin } from './api-client/getApiOrigin'

export const getPublicAuth = async () => {
  const key = 'fghrtrvdfger'
  const res = await fetch(`${getApiOrigin({})}/increase.php`)
  const serverTime = await res.json() as number
  return md5(`${serverTime.toString().substring(0, 7)}${key}`).toString()
}
